import { PqrFilter } from '../../../../../shared/types/modules/pqr';

export const initialValues: PqrFilter = {
    caseId: '',
    pqrId: '',
    sfcId: '',
    document: '',
    name: '',
    receptionChannel: [],
    half: [],
    type: [],
    branch: [],
    incharge: [],
    reconsideration: [],
    survey: false,
    correspondenceFiling: '',
    status: [],
    reception: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
};
